<template>
    <div id="ClaimCollection">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Claim Collection</div>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <!-- <router-link class="btn btn-secondary" v-bind:to="{name: 'WarrantyClaimList'}" > <i class="fp-back"> </i> Back</router-link> -->
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click.prevent="BackWarrantyList" > <i class="fp-back"> </i> Back</a>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content claim-collection">
                        <section class="internal-container border-top-table-fl">
                            <div class="form-row section-divider">
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Warranty Claim:</label>
                                        <span class="col"> {{ claim_number }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Claim Date:</label>
                                        <span class="col"> {{ claim_date }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Work Order Item:</label>
                                        <span class="col"> {{ wo_item }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Unit No:</label>
                                        <span class="col"> {{ unit_no }} </span>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row form-group">
                                        <label class="col">Claim Type:</label>
                                        <span class="col"> {{ claim_type }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Vendor Claim:</label>
                                        <span class="col"> {{ vendor_claim_number }} </span>
                                    </div>
                                    <div class="row form-group">
                                        <label class="col">Vendor:</label>
                                        <span class="col"> {{ vendor }} </span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 pull-right">
                                <table aria-describedby="table" class="table table-sm table-bordered" style="font-size:14px;">
                                    <tbody>
                                        <tr>
                                            <td class="bg-gray valign-middle"> Original Cost Claimed: </td>
                                            <td class="text-right"> <span v-if="cost_claimed != ''">${{cost_claimed}} </span></td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Collection To Date: </td>
                                            <td class="text-right"><span v-if="collection_amount_till_date != '' && collection_amount_till_date != undefined"> ${{collection_amount_till_date}} </span></td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Adjustment To Date: </td>
                                            <td class="text-right font-semibold"> <span v-if="adjustment_amount_till_date != '' && adjustment_amount_till_date != undefined">${{adjustment_amount_till_date}}</span> </td>
                                        </tr>
                                        <tr>
                                            <td class="bg-gray"> Outstanding Balance: </td>
                                            <td class="text-right font-semibold"> <span v-if="outstanding_balance != ''">${{outstanding_balance}} </span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="clearfix"></div>
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="CollectionForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="code"># Collection:</label>
                                        <input type="text" class="form-control" :disabled='true' v-model="collection_number" id="collection_number" placeholder="Enter Claim Number" name="collection_number">
                                        <!-- <div class="field-error">{{claim_number_error_msg}}</div> -->
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="cost_claimed">Collection Amount:</label>
                                        <input type="text" class="form-control text-right" v-model="collection_amount" id="collection_amount" @input="calculateRemain($event ,'collection')" placeholder="Enter Cost" name="collection_amount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{collection_amount_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="cost_claimed">Adjustment Amount:</label>
                                        <input type="text" class="form-control text-right" v-model="adjustment_amount" id="adjustment_amount" placeholder="Enter Cost" @input="calculateRemain($event ,'adjustment')" name="adjustment_amount" @keypress="isAmountCheck($event)">
                                        <!-- <div class="field-error">{{collection_amount_error_msg}}</div> -->
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label" for="remaining_amount">Remaining Amount:</label>
                                        <input type="text" class="form-control text-right" v-model="remaining_amount" id="remaining_amount" :disabled="true" placeholder="Remain Cost" name="remaining_amount" @keypress="isAmountCheck($event)">
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label require" for="claim_date">Date Collected:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="collection_date" name="collection_date" v-model="collection_date" :config="optionsDate"></date-picker>
                                            <label for="collection_date" class="fp-calendar input-calender-icon"></label>
                                        </div>
                                        <div class="field-error">{{ collection_date_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="period">Disposition:</label>
                                        <v-select class="close-remove" v-model="disposition" name="disposition" placeholder="Disposition"
                                            label="text" :options="dispositionArr">
                                        </v-select>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="period">Credit Memo #:</label>
                                        <input type="text" class="form-control" v-model="credit_memo" id="credit_memo" placeholder="Enter Credit Memo" name="credit_memo">
                                        <!-- <div class="field-error">{{miles_error_msg}}</div> -->
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createCollectionBtn" v-if="$route.params.id > 0 && flag == undefined || (flag != undefined && flag == 'update' )" class="btn btn-primary" v-on:click.prevent="createClaimCollection">
                                    <i class="fp-reload"> </i>  Update
                                    </button>

                                    <button type="submit" id="createCollectionBtn" v-else class="btn btn-primary" v-on:click.prevent="createClaimCollection" >
                                    <i class="fp-save"> </i>  Save
                                    </button>

                                    <button type="submit" id="createAndContinueCollectionBtn" v-if="$route.params.id == undefined && itemId == undefined" class="btn btn-tertiary" v-on:click.prevent="createClaimCollection(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>

                                    <button type="submit" id="cancelCollectionBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarrantyList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ClaimCollectionList",
        metaInfo() {
            return {title: "Claim Collection | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins, contractMixins, dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            term_value: false,
            loading:false,
            canUpdateProgram:false,
            canAddProgram:false,
            claim_number: "",
            description: "",
            warranty: null,
            wo_item_id:null,
            effective_date: "",
            period: "",
            periodTypeArr:[{value:"month",text:"Month"},{value:"year",text:"Year"}],
            periodType:{value:"month",text:"Month"},
            miles:"",
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            },
            vendor:'',
            vendor_claim_number:'',
            disposition:'',
            cost_claimed:0,
            claim_date:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            wo_item:'',
            claim_type:'',
            collection_amount:'',
            adjustment_amount:'',
            outstanding_balance:'',
            claim_number_error_msg:'',
            itemId:'',
            collection_amount_error_msg:'',
            collection_date:'',
            collection_date_error_msg:'',
            credit_memo:'',
            flag:'',
            remaining_amount:'',
            collection_amount_till_date:'',
            adjustment_amount_till_date:'',
            collection_number:'',
            old_collection_amount:'',
            old_adjustment_amount:'',
            unit_no:'',
            claimTypeArr:[],
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_claim_collection') {
                            self.cantAccessPage = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            self.loadFieldData(['claim_types']);

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]){
              self.loadCollectionData(segments[3]);
            }else if (segments[2]){
              self.loadClaimData(segments[2]);
            }

        },
        methods: {
            BackWarrantyList:function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (self.$route.query.from != undefined && self.$route.query.from == 'view'){
                    self.$router.push("/claim-collection/view/"+segments[3]);
                }else
                if (self.$route.query.claim != undefined && self.$route.query.claim > 0){
                    self.$router.push("/list/claim-collection");
                }else
                if (segments[3]){
                    self.$router.push("/warranty-claim/list");

                }else if (segments[2]){
                    self.$router.push("/warranty-claim/list");

                }
            },

            loadClaimData:function(claimId){
                var self = this;

                self.$parent.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-claim/fetch/"+claimId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.$parent.loading = false;
                        // self.wo_item = data.content;
                        self.wo_item = data.content.work_order_no+' | '+data.content.code+' | '+data.content.task;
                        self.claim_number = data.content.claim_number;
                        self.warranty = data.content.warName+'('+data.content.warCode+')';
                        self.failure_date = data.content.failure_date;
                        self.claim_date = data.content.claim_date;
                        self.cost_claimed = data.content.cost_claimed;
                        self.collection_number = data.content.collection_number;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.collection_amount_till_date = data.content.collection_amount_till_date;
                        self.adjustment_amount_till_date = data.content.adjustment_amount_till_date;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.old_collection_amount = data.content.collection_amount;
                        self.old_adjustment_amount = data.content.adjustment_amount;
                        for(var i =0;i < self.claimTypeArr.length;i++){
                            if (self.claimTypeArr[i].code == data.content.claim_type){

                                self.claim_type = self.claimTypeArr[i].text;

                            }
                        }
                        for(var j =0;j < self.dispositionArr.length;j++){
                            if (self.dispositionArr[j].value == data.content.disposition){

                                self.disposition = {text:self.dispositionArr[j].text,value:data.content.disposition};

                            }
                        }

                        self.description = data.content.description;
                        self.vendor_claim_number = data.content.vendor_claim_number;
                        if (data.content.vendor_id){
                            self.vendor = data.content.veName;
                        }
                        if (data.content.unit_no != undefined && data.content.unit_no != null) {
                            self.unit_no = data.content.unit_no;
                        }else{
                            self.unit_no = "-";
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.$parent.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                    }
                });
            },
            loadCollectionData:function(collectionId){
                var self = this;

                self.$parent.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/claim-collection/fetch/"+collectionId,
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.$parent.loading = false;
                        // self.wo_item = data.content;
                        self.wo_item = data.content.work_order_no+' | '+data.content.code+' | '+data.content.task;
                        self.claim_number = data.content.claim_number;
                        self.warranty = data.content.warName+'('+data.content.warCode+')';
                        self.failure_date = data.content.failure_date;
                        self.claim_date = data.content.claim_date;
                        self.cost_claimed = data.content.cost_claimed;
                        self.collection_number = data.content.collection_number;
                        self.outstanding_balance = data.content.outstanding_balance;
                        self.collection_amount = data.content.collection_amount;
                        self.adjustment_amount = data.content.adjustment_amount;
                        self.collection_date = data.content.collection_date;
                        self.credit_memo = data.content.credit_memo;
                        self.collection_amount_till_date = data.content.collection_amount_till_date;
                        self.adjustment_amount_till_date = data.content.adjustment_amount_till_date;
                        self.old_collection_amount = data.content.collection_amount;
                        self.old_adjustment_amount = data.content.adjustment_amount;
                        for(var i =0;i < self.claimTypeArr.length;i++){
                            if (self.claimTypeArr[i].code == data.content.claim_type){

                                self.claim_type = self.claimTypeArr[i].text;

                            }
                        }
                        for(var j =0;j < self.dispositionArr.length;j++){
                            if (self.dispositionArr[j].value == data.content.disposition){

                                self.disposition = {text:self.dispositionArr[j].text,value:data.content.disposition};

                            }
                        }

                        self.description = data.content.description;
                        self.vendor_claim_number = data.content.vendor_claim_number;
                        if (data.content.vendor_id){
                            self.vendor = data.content.veName;
                        }
                        if (data.content.unit_no != undefined && data.content.unit_no != null) {
                            self.unit_no = data.content.unit_no;
                        }else{
                            self.unit_no = "-";
                        }
                        self.calculateRemain('','load');
                    },
                    error: function (jqXHR, exception) {
                        self.$parent.loading = false;
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'asset-group-warranties-search')
                    }
                });
            },

            createClaimCollection(flag) {

                var self = this;
                var error = false;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.collection_date_error_msg = "";
                // self.collection_number_error_msg = "";
                self.collection_amount_error_msg = '';

                if (!self.collection_amount || self.collection_amount == null || self.collection_amount == "") {
                    self.collection_amount_error_msg = "Collection Amount is required.";
                    error = true;
                }

                if (!self.collection_date || self.collection_date == null || self.collection_date == "") {
                    self.collection_date_error_msg = "Collection Date is required.";
                    error = true;
                }

                var totalAdjusted = 0;
                if (self.collection_amount != '' && self.collection_amount != 0 ){
                    totalAdjusted = parseFloat(self.collection_amount);
                }
                if (self.adjustment_amount != '' && self.adjustment_amount != 0 ){
                    totalAdjusted += parseFloat(self.adjustment_amount);
                }

                if (segments[3]){
                    var allTotal = parseFloat(self.adjustment_amount_till_date) + parseFloat(self.collection_amount_till_date);
                    var t = parseFloat(self.old_collection_amount) + parseFloat(self.old_adjustment_amount);
                    var remain = self.cost_claimed - (allTotal - t);

                    if (totalAdjusted > remain){
                        self.$swal('','Collection should not be greater than outstanding amount','info');
                        error = true;
                    }

                }else{
                    if (totalAdjusted.toFixed(2) > self.outstanding_balance.toFixed(2)){
                        self.$swal('','Collection should not be greater than outstanding amount','info');
                        error = true;
                    }
                }


                if (!error) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var id = '';
                    if (self.itemId != undefined){
                        if (self.claimId != '' && self.claimId != undefined){
                            id = self.claimId;
                        }
                    }else{
                        if (segments[3]){
                            id = segments[3];
                        }
                    }

                    if (id != '')
                    {
                        $("#createCollectionBtn").val("Updating ...");
                        $("#createCollectionBtn").prop("disabled", true);
                        $("#cancelCollectionBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueCollectionBtn").val("Saving ...");
                            $("#createCollectionBtn").prop("disabled", true);
                            $("#createAndContinueCollectionBtn").prop("disabled", true);
                            $("#cancelCollectionBtn").prop("disabled",true);

                        }else{

                            $("#createCollectionBtn").val("Saving ...");
                            $("#createCollectionBtn").prop("disabled", true);
                            $("#createAndContinueCollectionBtn").prop("disabled", true);
                            $("#cancelCollectionBtn").prop("disabled",true);
                        }

                    }

                    var fields = $('#CollectionForm').serializeArray();

                    fields.push({name: "disposition", value: self.disposition.value});
                    fields.push({name: "claim_id", value: segments[2]});
                    fields.push({name: "collection_number", value: self.collection_number});
                    fields.push({name: "remaining_amount", value: self.remaining_amount});

                    if (segments[3]){

                        fields.push({name: "id", value: segments[3]});

                    }

                    $.ajax({
                        url: process.env.ROOT_API + "/claim-collection/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (id != '')
                            {
                                $("#createCollectionBtn").val("Update");
                                $("#createCollectionBtn").prop("disabled", false);
                                $("#cancelCollectionBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueCollectionBtn").val("Save and Continue");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }else{

                                    $("#createCollectionBtn").val("Save");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    $("#CollectionForm").trigger("reset");
                                    self.wo_item = '';
                                    self.collection_amount = '';
                                    self.collection_date = '';
                                    self.adjustment_amount = '';
                                    self.credit_memo = '';

                                }else{
                                    self.$router.push("/claim-collection/view/"+data.content.id+'?claim='+data.content.claim_id);
                                }

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (id != '')
                            {
                                $("#createCollectionBtn").val("Update");
                                $("#createCollectionBtn").prop("disabled", false);
                                $("#cancelCollectionBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    // $("#VehicleStatusForm").trigger("reset");

                                    $("#createAndContinueCollectionBtn").val("Save and Continue");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }else{

                                    $("#createCollectionBtn").val("Save");
                                    $("#createCollectionBtn").prop("disabled", false);
                                    $("#createAndContinueCollectionBtn").prop("disabled", false);
                                    $("#cancelCollectionBtn").prop("disabled",false);

                                }
                            }
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("tkn");

                                    self.$router.push("/");
                                }
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }
                    });
                }
            },
            calculateRemain:function(evt,flag){
                var self = this;
                var total = 0;

                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]){
                  if (parseFloat(self.collection_amount) !== 0) {
                      total = parseFloat(self.collection_amount);
                  }
                  if (self.adjustment_amount !== '' && parseFloat(self.adjustment_amount) !== 0) {
                      total += parseFloat(self.adjustment_amount);
                  }

                  if (flag == 'load') {
                      var remAmount = self.outstanding_balance + total - total;
                      self.remaining_amount = remAmount.toFixed(2);
                  } else {
                      var allTotal = parseFloat(self.adjustment_amount_till_date) + parseFloat(self.collection_amount_till_date);
                      var t = parseFloat(self.old_collection_amount) + parseFloat(self.old_adjustment_amount);
                      var remain = self.cost_claimed - (allTotal - t);

                      var remAmount = remain - total;
                      self.remaining_amount = remAmount.toFixed(2);
                  }

                }else{
                  if (parseFloat(self.collection_amount) !== 0) {
                      total = parseFloat(self.collection_amount);
                  }
                  if (self.adjustment_amount !== '' && parseFloat(self.adjustment_amount) !== 0) {
                      total += parseFloat(self.adjustment_amount);
                  }

                  if (flag == 'load') {
                      var remAmount = self.outstanding_balance + total - total;
                      self.remaining_amount = remAmount.toFixed(2);
                  } else {
                      var remAmount = parseFloat(self.outstanding_balance.toFixed(2)) - total;
                      self.remaining_amount = remAmount.toFixed(2);
                  }

                }

            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ClaimCollection.vue